const requireModule = require.context('.', true, /\.vue$/)
import Router from '@/router'
import { getCustomSteps } from '@/utils'
import { path } from 'ramda'

const data = requireModule
  .keys()
  .sort()
  .filter(fileName => {
    if (fileName.endsWith('index.js')) return false
    return true
  })

export default function (item) {
  let base = data.reduce((res, fileName) => {
    const module = requireModule(fileName)

    const skip = typeof module.meta.skip === 'function' ? module.meta.skip(item) : module.meta.skip

    if (skip) return res

    res.push({
      component: module.default,
      ...module.meta,
    })

    return res
  }, [])

  const postCollections = (path(['metadata', 'postCollections'], item) || []).map((collection, index) => ({
    order: 500 + index,
    id: `posts-${collection.id}`,
    label: collection.label.split('|').pop(),
    icon: collection.icon,
    component: requireModule('./PostCollection.vue').default,
    isValid: true,
    props: {
      id: Router.app.$route.params.id,
      collection: collection.id,
      actionPortalName: 'model-template-posts-empty-state-actions',
      embedded: true,
    },
  }))

  let steps = [...base, ...postCollections]

  const stepOverwrite = path(['metadata', 'editStepsOrder'], item) || []

  if (stepOverwrite.length) steps = getCustomSteps(stepOverwrite, 'modelTemplate', { overwriteFrom: steps, item })

  return steps.sort((a, b) => {
    if (!stepOverwrite.length) return a.order - b.order

    let aIndex = stepOverwrite.indexOf(a.rawId || a.id)
    let bIndex = stepOverwrite.indexOf(b.rawId || b.id)

    if (aIndex === -1 && bIndex === -1) return a.order - b.order
    if (aIndex === -1) return 1
    if (bIndex === -1) return -1

    return aIndex - bIndex
  })
}
